import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import useKeyboardShortcutBlocker from "./KeyboardShortcutBlocker";
import { message, Form, Input, Button, Alert } from "antd";
import { useNavigate, Link, useLocation } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import Slider from "react-slick";
import { GoPlus } from "react-icons/go";
import { FiMinus } from "react-icons/fi";
import { CiGlobe } from "react-icons/ci";
import { CiClock2 } from "react-icons/ci";
import { CiCalendar } from "react-icons/ci";
import { Headernew } from "./Headernew";

import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { FiUserPlus } from "react-icons/fi";
import { FaCheckCircle } from "react-icons/fa";
import { FaExternalLinkAlt } from "react-icons/fa";
import { AiOutlineExclamationCircle } from "react-icons/ai";

const data = [
  {
    id: 1,
    title: "Accordion Item 1",
    content: "This is the content for item 1.",
  },
  {
    id: 2,
    title: "Accordion Item 2",
    content: "This is the content for item 2.",
  },
  {
    id: 3,
    title: "Accordion Item 3",
    content: "This is the content for item 3.",
  },
  {
    id: 4,
    title: "Accordion Item 4",
    content: "This is the content for item 4.",
  },
  {
    id: 5,
    title: "Accordion Item 5",
    content: "This is the content for item 5.",
  },
];

export const Bookingmeet = () => {
  const [spinner, setspinner] = useState(false);
  const [submissionschedule, setsubmissionschedule] = useState(false);
  const [datemetting, setdatemetting] = useState("");
  const [timeset, settime] = useState("");
  const [activenow, setactivenow] = useState(false);
  const [mainsection, setmainsection] = useState(true);
  const [value, setValue] = useState(new Date());
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeFormat, setActiveFormat] = useState("12h");
  const [availableTimes, setAvailableTimes] = useState([]);
  const [guests, setGuests] = useState([""]);
  const [formdatamail, setformdatamail] = useState("");

  const timeSlots = [
    "10:00 am",
    "10:30 am",
    "11:00 am",
    "11:30 am",
    "12:00 pm",
    "12:30 pm",
    "01:00 pm",
    "01:30 pm",
    "02:00 pm",
    "02:30 pm",
    "03:00 pm",
    "03:30 pm",
    "04:00 pm",
    "04:30 pm",
  ];
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const userStr = JSON.parse(localStorage.getItem("users"));
  // useKeyboardShortcutBlocker();
  const addGuest = () => {
    setGuests([...guests, ""]);
  };
  useEffect(() => {
    changeFavicon(require("./assets/admin/images/f-icon.png"));
    const userStr = JSON.parse(localStorage.getItem("users"));

    document.title = "Meeting Book Page";
  }, []);
  const handleGuestChange = (index, value) => {
    const updatedGuests = [...guests];
    updatedGuests[index] = value;
    setGuests(updatedGuests);
  };
  var settings_2 = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "0px",
          slidesToShow: 1,
        },
      },
    ],
  };
  const disablePastDates = ({ date, view }) => {
    // Only disable days in month/day view
    if (view === "month") {
      const today = new Date();
      // Remove time from today for clean comparison
      today.setHours(0, 0, 0, 0);
      return date < today;
    }
  };
  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long", // Thursday
      year: "numeric", // 2025
      month: "long", // April
      day: "numeric", // 17
    });
  };
  const handleDayClick = (date) => {
    const formattedDate = formatDate(date);
    setdatemetting(formattedDate);
    setValue(date);

    loadAvailableTimes(date);
  };

  const isTimeAfterCurrent = (timeStr, currentTime) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "pm" && hours !== 12) hours += 12;
    if (modifier === "am" && hours === 12) hours = 0;

    const slotDate = new Date();
    slotDate.setHours(hours, minutes, 0, 0);

    return slotDate.getTime() > currentTime.getTime();
  };
  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = formatDate(currentDate);
    setdatemetting(formattedDate);
    setValue(currentDate);

    loadAvailableTimes(currentDate);
  }, []);

  const loadAvailableTimes = (date) => {
    const selectedDateStr = date.toDateString();
    const todayStr = new Date().toDateString();

    if (selectedDateStr === todayStr) {
      const currentTime = new Date();
      const filteredTimes = timeSlots.filter((time) =>
        isTimeAfterCurrent(time, currentTime)
      );
      setAvailableTimes(filteredTimes);
    } else {
      setAvailableTimes(timeSlots);
    }
  };
  const handletime = (dtime) => {
    var mettime = formatTimeRange(dtime);
    settime(mettime);
    setspinner(false);
    setactivenow(true);
  };
  const formatTimeRange = (timeStr) => {
    // Create a date with today's date and given time string
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier.toLowerCase() === "pm" && hours !== 12) {
      hours += 12;
    }
    if (modifier.toLowerCase() === "am" && hours === 12) {
      hours = 0;
    }

    const startDate = new Date();
    startDate.setHours(hours);
    startDate.setMinutes(minutes);
    startDate.setSeconds(0);

    // Add 25 minutes
    const endDate = new Date(startDate.getTime() + 25 * 60000);

    // Format both times
    const formatTime = (date) => {
      let hrs = date.getHours();
      const mins = String(date.getMinutes()).padStart(2, "0");
      const ampm = hrs >= 12 ? "pm" : "am";
      hrs = hrs % 12;
      hrs = hrs ? hrs : 12; // 0 => 12
      return `${String(hrs).padStart(2, "0")}:${mins} ${ampm}`;
    };

    return `${formatTime(startDate)} - ${formatTime(endDate)}`;
  };
  const [timeZone, setTimeZone] = useState("");
  const handlesubmit = (e) => {
    e.preventDefault();
    setspinner(true);
    let formdata = {
      full_name: e.target.full_name.value,
      email: e.target.email.value,
      goals: e.target.goals.value,
      started: e.target.started.value,
      notes: e.target.notes.value,
      goals: e.target.goals.value,
      timeZone: timeZone,
      guests: guests,
      datemetting: datemetting,
      timeset: timeset,
    };
    setformdatamail(formdata);

    axios
      .post("https://jlmining.app/api/adminsupervisor/bookmeet", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setmainsection(false);
        setspinner(false);
        setsubmissionschedule(true);
      })
      .catch((err) => { });
  };

  const backsection = () => {
    setactivenow(false);
  };

  useEffect(() => {
    // On page load, get user's current timezone
    const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimeZone(currentTimeZone);
  }, []);
  const timezones = Intl.supportedValuesOf("timeZone");
  const handlecliktimezone = (event) => {
    const ss = event.target.value;
    setTimeZone(ss);
  };
  return (
    <>
      <Headernew />
      <section className="inbanner d-block">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              <div className="d-flex flex-column gap-2 text-center">
                <h1>Book an Introductory Call</h1>
                <h2>
                  Please select a time below to book a call with our team.
                </h2>
                <h3>or</h3>
                <h4>
                  Make a direct call to speak with one of our manager 1234567890
                </h4>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="calbox d-block">
        <div className="container-lg">
          <div className="row">
            <div className="col-12">
              {mainsection && (
                <div className="d-block calcublock">
                  <div className="row gy-4">
                    <div className="col-lg-3">
                      <div className="d-flex flex-column h-100">
                        <div className="d-flex flex-column textmenu">
                          <h3>Jl Mining</h3>
                          <h2>
                            Jl Mining
                            <br />
                            Introduction
                          </h2>
                          <div className="scrollmenu d-block">
                            <p>I'm excited for our intro conversation!</p>
                            <p>Here’s a quick rundown of what to expect:</p>
                            <p>
                              • <strong>Introductions</strong> – A quick hello
                            </p>
                            <p>
                              • <strong>Project Goals</strong> – Understanding
                              your vision, needs, and challenges
                            </p>
                            <p>
                              • <strong>&amp;A</strong> – Answering any
                              questions you have about our process or
                              capabilities
                            </p>
                            <p>
                              • <strong>Next Steps</strong> – Outlining the best
                              path forward
                            </p>
                            <p>Looking forward to connecting!</p>
                            <p>I'm excited for our intro conversation!</p>
                            <p>Here’s a quick rundown of what to expect:</p>
                            <p>
                              • <strong>Introductions</strong> – A quick hello
                            </p>
                            <p>
                              • <strong>Project Goals</strong> – Understanding
                              your vision, needs, and challenges
                            </p>
                            <p>
                              • <strong>&amp;A</strong> – Answering any
                              questions you have about our process or
                              capabilities
                            </p>
                            <p>
                              • <strong>Next Steps</strong> – Outlining the best
                              path forward
                            </p>
                            <p>Looking forward to connecting!</p>
                          </div>
                        </div>
                        <div className="d-flex flex-column gap-2 mt-auto menusec">
                          {timeset !== "" && (
                            <div className="d-flex gap-2 align-items-center">
                              <div className="flex-shrink-0">
                                <CiCalendar />
                              </div>
                              <div className="flex-grow-1">
                                <p>
                                  {datemetting} {timeset}
                                </p>
                              </div>
                            </div>
                          )}
                          <div className="d-flex gap-2 align-items-center">
                            <div className="flex-shrink-0">
                              <CiClock2 />
                            </div>
                            <div className="flex-grow-1">
                              <p>25m</p>
                            </div>
                          </div>
                          <div className="block">
                            <div className="d-flex gap-2 align-items-center">
                              <div className="flex-shrink-0">
                                <CiGlobe />
                              </div>
                              <div className="flex-grow-1 text-white">
                                <select
                                  value={timeZone}
                                  className="form-select"
                                  onChange={handlecliktimezone}
                                >
                                  {timezones.map((tz, index) => (
                                    <option key={index} value={tz}>
                                      {tz}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {!activenow && (
                      <div className="col-lg-6">
                        <Calendar
                          onChange={handleDayClick}
                          value={value}
                          tileDisabled={disablePastDates}
                        />
                      </div>
                    )}
                    {!activenow && (
                      <div className="col-lg-3">
                        <div className="d-flex flex-column gap-3">
                          <div className="d-flex justify-content-between align-items-center">
                            <h3 className="weekdate">
                              Wed <span>30</span>
                            </h3>

                            <div className="timefbtn d-flex gap-2">
                              <button
                                type="button"
                                className={
                                  activeFormat === "12h" ? "active" : ""
                                }
                                onClick={() => setActiveFormat("12h")}
                              >
                                12h
                              </button>
                              <button
                                type="button"
                                className={
                                  activeFormat === "24h" ? "active" : ""
                                }
                                onClick={() => setActiveFormat("24h")}
                              >
                                24h
                              </button>
                            </div>
                          </div>
                          <div className="d-flex flex-column gap-2 timebtns text-center">
                            {availableTimes.length > 0 ? (
                              availableTimes.map((time, index) => (
                                <button
                                  type="button"
                                  onClick={() => handletime(time)}
                                  key={index}
                                >
                                  {time}
                                </button>
                              ))
                            ) : (
                              <p>No available time slots.</p>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {activenow && (
                      <div className="col-lg-8 p-5">
                        <form method="post" onSubmit={handlesubmit}>
                          <div className="bookblock d-block">
                            <div className="d-flex flex-column gap-3">
                              <div className="d-flex flex-column gap-2">
                                <label htmlFor="">
                                  Your name <sup>*</sup>
                                </label>
                                <input
                                  required
                                  name="full_name"
                                  type="text"
                                  placeholder="full name"
                                />
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <label htmlFor="">
                                  Email address <sup>*</sup>
                                </label>
                                <input
                                  type="email"
                                  required
                                  name="email"
                                  placeholder="your email"
                                />
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <label htmlFor="">
                                  Share some information about your design
                                  goals. <sup>*</sup>
                                </label>
                                <input
                                  type="text"
                                  required
                                  name="goals"
                                  placeholder=""
                                />
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <label htmlFor="">
                                  How soon do you want to get started?{" "}
                                  <sup>*</sup>
                                </label>
                                <select name="started" required>
                                  <option value="">--Select--</option>
                                  <option value="ASAP">ASAP</option>
                                  <option value="2 weeks">2 weeks</option>
                                  <option value="1 month">1 month</option>
                                  <option value="Uncertain">Uncertain</option>
                                </select>
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <label htmlFor="">Additional notes</label>
                                <textarea
                                  rows="4"
                                  name="notes"
                                  id=""
                                  placeholder="Please share anything that will help prepare for our meeting."
                                ></textarea>
                              </div>
                              <div className="d-flex flex-column gap-2">
                                <label htmlFor="">Add guests</label>
                                {guests.map((guest, index) => (
                                  <input
                                    key={index}
                                    type="email"
                                    name={`guest_user_${index}`}
                                    placeholder="Email"
                                    value={guest}
                                    onChange={(e) =>
                                      handleGuestChange(index, e.target.value)
                                    }
                                  />
                                ))}
                              </div>
                              <div className="addanother">
                                <button type="button" onClick={addGuest}>
                                  <div className="d-flex gap-2 align-items-center">
                                    <FiUserPlus /> <span>Add another</span>
                                  </div>
                                </button>
                              </div>
                              <p>
                                By proceeding, you agree to our
                                <a href="#">Terms</a> and{" "}
                                <a href="#">Privacy Policy.</a>
                              </p>
                              <div className="d-flex justify-content-end">
                                <div className="d-flex gap-2 align-items-center btmbtns">
                                  <button
                                    type="button"
                                    style={{
                                      opacity: spinner ? 0.5 : 1,
                                      pointerEvents: spinner ? "none" : "auto",
                                    }}
                                    onClick={backsection}
                                  >
                                    Back
                                  </button>
                                  <button
                                    type="submit"
                                    style={{
                                      opacity: spinner ? 0.5 : 1,
                                      pointerEvents: spinner ? "none" : "auto",
                                    }}
                                  >
                                    Confirm
                                  </button>
                                  {spinner && (
                                    <div
                                      class="spinner-border text-success"
                                      role="status"
                                    >
                                      <span class="visually-hidden">
                                        Loading...
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {submissionschedule && (
                <div className="d-block calcublock">
                  <div className="row justify-content-center">
                    <div className="col-lg-7">
                      <div className="inwidth p-4">
                        <div className="d-flex flex-column gap-4">
                          <div className="d-flex flex-column gap-3 text-center meettop">
                            <div className="meetbox">
                              <FaCheckCircle className="checkicon" />
                              <div className="metpic">
                                <img
                                  src={require("./assets/images/open-folder_5994725.png")} // Replace with your folder image path
                                  alt="Folder"
                                />
                              </div>
                            </div>
                            <h3>This meeting is scheduled</h3>
                            <p>
                              Christian O'Brien is meeting with{" "}
                              {formdatamail.full_name}. We sent an email with a
                              calendar invitation with the details to everyone.
                            </p>
                          </div>
                          <hr className="lineb my-1" />
                          <div className="row gy-4 menures">
                            <div className="col-4">
                              <h5>
                                <b>What</b>
                              </h5>
                            </div>
                            <div className="col-8">
                              <h5>
                                Off Menu Introduction between Christian O'Brien
                                and name
                              </h5>
                            </div>
                            <div className="col-4">
                              <h5>
                                <b>When</b>
                              </h5>
                            </div>
                            <div className="col-8">
                              <h5>
                                {datemetting} {timeset} {timeZone}
                              </h5>
                            </div>
                            <div className="col-4">
                              <h5>
                                <b>Who</b>
                              </h5>
                            </div>
                            <div className="col-8">
                              <h5>
                                Christian O'Brien <br />
                                <span>Host</span> <br />
                                christian@offmenu.design
                                {formdatamail.full_name}
                                {formdatamail.guests &&
                                  formdatamail.guests.length > 0 ? (
                                  formdatamail.guests.map((guest, index) => (
                                    <p key={index}>{guest}</p>
                                  ))
                                ) : (
                                  <p>No guests added.</p>
                                )}
                              </h5>
                            </div>

                            <div className="col-12">
                              <div className="d-flex flex-column">
                                <h5>
                                  <b>
                                    Share some information about your design
                                    goals.
                                  </b>
                                </h5>
                                <h5> {formdatamail.goals}</h5>
                              </div>
                            </div>
                            <div className="col-12">
                              <div className="d-flex flex-column">
                                <h5>
                                  <b>How soon do you want to get started?</b>
                                </h5>
                                <h5>{formdatamail.started}</h5>
                              </div>
                            </div>
                          </div>
                          <hr className="lineb my-1" />
                          <div className="d-block text-center resce">
                            <p>
                              Need to make a change? <a href="#">Reschedule</a>{" "}
                              or <a href="#">Cancel</a>
                            </p>
                          </div>
                          <hr className="lineb my-1" />
                          <div className="d-flex flex-column gap-3 text-center ownbooking">
                            <p>Create your own booking link with Cal.com</p>
                            <form action="">
                              <div className="inbooking d-flex">
                                <div className="flex-grow-1">
                                  <input type="text" placeholder="" />
                                </div>
                                <div className="flex-shrink-0">
                                  <button type="submit">Tryit for free</button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="warbox mt-3">
                        <div className="d-flex gap-2">
                          <div className="flex-shrink-0">
                            <AiOutlineExclamationCircle />
                          </div>
                          <div className="flex-grow-1">
                            <p>
                              Google’s new spam policy could prevent you from
                              receiving any email and calendar notifications
                              about this booking.
                            </p>
                            <a href="#">Resolve</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="faqblock d-block">
        <div className="container-lg">
          <div className="row gy-4">
            <div className="col-12">
              <div className="d-flex flex-column ftitle">
                <h2>
                  Frequently <br /> <span>asked questions</span>
                </h2>
              </div>
            </div>
            <div className="col-12">
              <div className="accordion faq">
                {data.map((item, index) => (
                  <div key={item.id} className="accordion-item">
                    <button
                      onClick={() => toggleAccordion(index)}
                      className="accordion-title"
                    >
                      <span>{item.title}</span>
                      <span className="accordion-icon">
                        {activeIndex === index ? (
                          <FiMinus size={20} />
                        ) : (
                          <GoPlus size={20} />
                        )}
                      </span>
                    </button>

                    {activeIndex === index && (
                      <div className="accordion-content">{item.content}</div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="workblock d-block">
        <div className="container-lg">
          <div className="row gy-5">
            <div className="col-12">
              <div className="d-flex justify-content-center text-center">
                <h2>
                  Work seamlessly with a hands-on team built for the field —
                  fast-paced, reliable, and{" "}
                  <span>deliver beyond expectations.</span>
                </h2>
              </div>
            </div>
            <div className="col-12">
              <h4 className="botmtitle">JLMining</h4>
            </div>
          </div>
        </div>
      </section>
      <section className="d-block py-5 our-partner">
        <div className="container-xl overflow-hidden">
          <div className="d-flex flex-column gap-2 pb-3">
            <h4>Our Trusted Partners</h4>
            <p>
              We deliver great results and we have cultivated long-term
              relationships with leading brands and companies.
            </p>
          </div>
          <Slider {...settings_2} className="logo-slider ">
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-hss.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-bird.webp")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/jl-logo.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-hunta.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img-h d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-minotaur.png")}
                alt="logo"
              />
            </div>
            <div className="logo-img d-block">
              <img
                className="w-100 h-100 object-fit-contain"
                src={require("./assets/banner/images/logo-walc.png")}
                alt="logo"
              />
            </div>
          </Slider>
        </div>
      </section>

      <footer>
        <div className="ft-topbox d-block py-5">
          <div className="container-lg">
            <div className="row gy-4">
              <div className="col-lg-3">
                <div className="d-flex flex-column gap-3 ft-boxes">
                  <h3>Contact us</h3>
                  <div className="d-flex flex-column gap-2 ft-links">
                    <p>Address: 8 Sparks Rd, Henderson WA 6166 </p>
                    <p>
                      <Link to="javascript:void(0)">Phone: +61 894375388</Link>{" "}
                    </p>
                    <p>Hours: 7:00am - 5:00pm Monday - Friday </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="d-flex flex-column gap-3 ft-boxes">
                  <h3>Help</h3>
                  <div className="row gy-4">
                    <div className="col-lg-6">
                      <div className="d-flex flex-column gap-2 ft-links">
                        <p>
                          <Link to="/contact">Contact Information</Link>{" "}
                        </p>
                        <p>
                          <Link to="javascript:void(0)">How to Use</Link>{" "}
                        </p>
                        <p>
                          <Link to="/experthelp">Get Expert Help</Link>{" "}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="d-flex flex-column gap-2 ft-links">
                        <p>
                          <Link to="/terms&condition">
                            Terms and Conditions
                          </Link>{" "}
                        </p>
                        <p>
                          <Link to="/privacypolicy">Privacy Policy</Link>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="d-flex flex-column gap-3 ft-boxes">
                  <h3>exprole us</h3>
                  <div className="d-flex flex-column gap-2 ft-links">
                    <p>
                      <Link to="https://www.hssonline.com.au" target="_blank">
                        www.hssonline.com.au
                      </Link>{" "}
                    </p>
                    <p>
                      <Link to="https://www.hssptyltd.com.au" target="_blank">
                        www.hssptyltd.com.au
                      </Link>{" "}
                    </p>
                    <p>
                      <Link to="https://www.jlme.com.au" target="_blank">
                        www.jlme.com.au{" "}
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copy-ft py-2 text-center">
          <div className="container-lg">
            <p>
              Privacy | Site Terms | &copy; {currentYear}, JL Mining All rights
              reserved
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};
